import React from "react";
import Table from "react-bootstrap/Table";
import { Modal } from "react-bootstrap";
import { formatDate, getArticleName } from "../../../../common/FunctionUtils";
import { AiOutlineClose } from "react-icons/ai";

export const ViewDateSummary = ({
  datesChanged,
  setDatesChanged,
  viewDate,
  t,
}) => {
  return (
    <Modal
      show={datesChanged}
      onHide={() => {
        setDatesChanged(false);
      }}
      size="xl"
      scrollable
      className="invoice-dialog"
    >
      <Modal.Header>
        <Modal.Title>{t("Calendar Summary")}</Modal.Title>
        <AiOutlineClose
          className="ml-auto cursor-pointer"
          size={24}
          onClick={() => {
            setDatesChanged(false);
          }}
        />
      </Modal.Header>
      <Modal.Body className="p-3">
        <div className="p-3">
          <Table responsive="sm" size="sm">
            <thead>
              <tr style={{ backgroundColor: "#5d47b6" }}>
                <th style={{ color: "white" }}>{t("Serial No.")}</th>
                <th style={{ color: "white" }}>{t("User Id")}</th>
                <th style={{ color: "white" }}>{t("Date")}</th>
                <th style={{ color: "white" }}>{t("Description")}</th>
                <th style={{ color: "white" }}>{t("Hours")}</th>
                <th style={{ color: "white" }}>{t("Invoice No")}</th>
              </tr>
            </thead>
            <tbody>
              {viewDate?.length ? (
                viewDate?.map((item, index) => (
                  <tr key={item?.id}>
                    <td>{index + 1}</td>

                    <td>{item?.userId}</td>
                    <td>
                      {t(formatDate(item?.workingDate)?.split(" ")[0])}{" "}
                      {formatDate(item?.workingDate)?.split(" ")[1]}{" "}
                      {formatDate(item?.workingDate)?.split(" ")[2]}{" "}
                    </td>
                    <td>{t(getArticleName(item?.articleNumber))}</td>
                    <td>{item?.number}</td>
                    <td>{item?.invoiceNumber}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>{t("No data found")}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};
